import { render } from "./Table.vue.js?vue&type=template&id=5540f41d!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./Table.vue?vue&type=template&id=5540f41d"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__